import { render, staticRenderFns } from "./HeroSky.vue?vue&type=template&id=2dc0a514&scoped=true"
import script from "./HeroSky.vue?vue&type=script&lang=js"
export * from "./HeroSky.vue?vue&type=script&lang=js"
import style0 from "./HeroSky.vue?vue&type=style&index=0&id=2dc0a514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0a514",
  null
  
)

export default component.exports